import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ButtonComponent } from '@recruitee/user-interface';

@Component({
  selector: 'rt-placeholder-button',
  templateUrl: './placeholder-button.component.html',
  styleUrls: ['./placeholder-button.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ButtonComponent],
})
export class PlaceholderButtonComponent {
  @Input() public disabled: boolean = false;

  private textWithoutBrackets: string;

  @Input()
  public set text(str: string) {
    this.textWithoutBrackets = str.slice(1, -1);
  }

  public get text(): string {
    return this.textWithoutBrackets;
  }
}
